import { render, staticRenderFns } from "./PlayAloudText.vue?vue&type=template&id=120385c8&scoped=true"
import script from "./PlayAloudText.vue?vue&type=script&lang=js"
export * from "./PlayAloudText.vue?vue&type=script&lang=js"
import style0 from "./PlayAloudText.vue?vue&type=style&index=0&id=120385c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120385c8",
  null
  
)

export default component.exports